import { Skeleton } from '@/components/ui'
import { cn } from '@/utils'

// Skeleton is an inline span; a block one stacks like the lines it stands in for.
const Line = ({ className }: { className: string }) => (
  <Skeleton className={cn('flex', className)} />
)

// Mirrors the loaded case page -- header, steps, documents, screening -- so the
// content lands where the placeholders were.
export const CaseSkeleton = () => (
  <div aria-busy className="mx-auto max-w-3xl space-y-8">
    <div className="space-y-6">
      <Line className="h-4 w-56" />
      <div className="flex items-start justify-between gap-4">
        <div className="space-y-1.5">
          <Line className="h-9 w-64" />
          <Line className="h-7 w-40" />
        </div>
        <Skeleton className="h-6 w-20 rounded-full" />
      </div>
    </div>

    <div className="flex flex-wrap items-center gap-2">
      {[0, 1, 2].map((index) => (
        <span key={index} className="flex items-center gap-2">
          {index > 0 && <span aria-hidden className="h-px w-6 bg-border" />}
          <Skeleton className="h-7 w-36 rounded-full" />
        </span>
      ))}
    </div>

    <section className="space-y-4">
      <div className="space-y-2">
        <Line className="h-6 w-40" />
        <Line className="h-4 w-80" />
      </div>
      <Line className="h-28 w-full" />
      <div className="space-y-2">
        <Line className="h-12 w-full" />
        <Line className="h-12 w-full" />
      </div>
    </section>

    <div className="space-y-3 border-t pt-8">
      <Line className="h-6 w-48" />
      <Line className="h-4 w-96" />
      <Line className="h-10 w-40" />
    </div>
  </div>
)
